import React from 'react';
import PropTypes from 'prop-types';
import { branch, renderComponent } from 'recompose';

import { containerApp } from '../../main';

const OverlaySpinner = ({ children }) => (
  <div className="c-loader">
    <span
      display-if={children}
      className="c-loader__title u-co-white u-fontsize-normal u-type--semibold"
    >
      {children}
    </span>
    <div className="c-loader__spin" data-automation-id="icon:loading" />
  </div>
);

OverlaySpinner.propTypes = {
  children: PropTypes.node,
};

OverlaySpinner.defaultProps = {
  children: null,
};

export default branch(
  props => props.showForContainerApp,
  renderComponent(OverlaySpinner),
)(containerApp.hideForContainerApp(OverlaySpinner));
